"use client";
import React from "react";
import Link from "next/link";

const CTASection = ({ onGetDemo }) => {
  return (
    <section className="relative py-24 bg-white overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-accent/10 rounded-full blur-[150px]" />
      </div>

      <div className="relative max-w-4xl mx-auto px-6 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent/10 border border-accent/20 mb-8">
          <span className="text-accent text-sm font-medium">Ready to transform your hiring?</span>
        </div>

        {/* Headline */}
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-jacarta-700 mb-6">
          Start hiring{" "}
          <span className="text-accent">
            smarter today
          </span>
        </h2>

        {/* Subtitle */}
        <p className="text-jacarta-500 text-lg md:text-xl max-w-2xl mx-auto mb-10">
          Join leading BFSI companies using SynthiaHire to screen, qualify, and interview candidates at superhuman speed.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button 
            onClick={() => onGetDemo && onGetDemo()}
            className="group relative px-8 py-4 bg-accent hover:bg-accent-dark rounded-xl font-semibold text-white transition-all duration-300 hover:shadow-lg hover:shadow-accent/25 hover:scale-105"
          >
            Get a Demo
            <span className="ml-2">→</span>
          </button>
          <Link href="/corporate/login">
            <a className="px-8 py-4 rounded-xl font-semibold text-jacarta-600 border border-jacarta-200 hover:bg-[#F3F1FA] hover:border-accent/30 transition-all duration-300">
              Start Free Trial
            </a>
          </Link>
        </div>

        {/* Trust note */}
        <p className="mt-8 text-jacarta-500 text-sm">
          No credit card required • Setup in minutes
        </p>
      </div>
    </section>
  );
};

export default CTASection;
